/* 十页原型（proto-shell 01–10）车型上下文（2026-09-24：10 月 1 日上线的基础框架）
   车型清单来自 snippets/auxito-proto-shell-vehicles.liquid（script[data-apsp-vehicles]）。

   1. 当前车型：网址参数 vehicle=<key> 或 year/make/model → 全站已保存车型（localStorage auxito_vehicles，与页头、06、
      search-result 同一份）→ 默认车型。只认清单里的车，其他车型回落到默认车型。
   2. 页面显示：[data-apsp-v] 元素按字段换成当前车型（name / year / make / model / make-model / year-model）；
      [data-apsp-only="key …"] 车型专属素材只在列出的车型上显示。
   3. 链接：
      - 原型页之间（href 或 data-*-link 里带 view=proto-shell-NN）→ 加 vehicle=<key>；目标页对该车还没有内容（清单 page_only）→ 改去该车 03；
      - 06 灯泡尺寸（view=proto-shell-06）→ 已上线的 06 页面（清单里的 bsg）；
      - search-result（/pages/search-result?q=…）→ 换成当前车型的年份 / 品牌 / 车型库原文；
      - 商品页（/products/…）→ 带 fit=veh_…，商品页显示 Fits On。
   4. 选车卡（assets/auxito-proto-shell-vehicle-card.js）通过 window.AuxitoProtoShellVehicle 取车型清单与跳转地址。
   Liquid 读不到网址参数，页面先按默认车型出，本脚本在浏览器里切换；本脚本须在页面内容之前加载。 */
(function () {
  'use strict';

  var script = document.querySelector('script[data-apsp-vehicles]');
  var data = null;
  try { data = script ? JSON.parse(script.textContent) : null; } catch (e) { data = null; }
  if (!data) return;

  /* 正式网址模式（上线 2026-09-28）：车型清单来自店铺元字段 auxito.vehicle_pages_index（紧凑格式，见 scripts/vehicle-pages-build-entries.py），
     页面间跳转换成标准 URL；没有索引时（开发预览兜底）沿用静态清单 + ?view=proto-shell-NN 预览网址。 */
  var formal = !!(data.formal && data.index && Array.isArray(data.index.vehicles) && data.index.vehicles.length);
  var PAGES = data.pages || {};
  var HOST = PAGES.host || '/pages/vehicles-bulb-size-guide-list';
  var locMap = formal ? (data.index.loc || {}) : {};
  var list;
  if (formal) {
    var posKeys = data.index.pos || [];
    var keysOf = function (idx) { return (idx || []).map(function (i) { return posKeys[i]; }); };
    list = data.index.vehicles.map(function (x) {
      return { key: x.k, year: String(x.y), make: x.mk, model: x.m, lib_model: x.l, bsg: x.b, yh: x.yh, mh: x.mh, fit: keysOf(x.f), inst: keysOf(x.i) };
    });
  } else {
    list = data.vehicles;
  }
  if (!Array.isArray(list) || !list.length) return;

  /* 标准网址页面（Metaobject 网页）由 section 输出本页车型 / 灯位：script[data-apsp-page]，优先于网址参数与已保存车型 */
  var pageCtx = null;
  try { var pc = document.querySelector('script[data-apsp-page]'); pageCtx = pc ? JSON.parse(pc.textContent) : null; } catch (e) { pageCtx = null; }
  var lc = function (s) { return String(s || '').trim().toLowerCase().replace(/\s+/g, ' '); };
  var byKey = function (key) { return list.filter(function (v) { return v.key === key; })[0] || null; };
  var match = function (year, make, model) {
    return list.filter(function (v) {
      return String(v.year) === String(year) && lc(v.make) === lc(make) && (lc(v.model) === lc(model) || lc(v.lib_model) === lc(model));
    })[0] || null;
  };
  var fallback = byKey(data.default) || list[0];

  function savedVehicle() {
    try {
      var c = (JSON.parse(window.localStorage.getItem('auxito_vehicles') || 'null') || {}).current;
      return c && c.year && c.make && c.model ? c : null;
    } catch (e) { return null; }
  }

  var params = new URLSearchParams(window.location.search);
  var fromUrl = byKey(params.get('vehicle')) || (params.get('year') ? match(params.get('year'), params.get('make'), params.get('model')) : null);
  var saved = savedVehicle();
  var savedMatch = saved ? match(saved.year, saved.make, saved.model) : null;
  // 本页车型：年份类页面直接取；车型中心页（只有车型没有年份）取已保存的同车型，否则该车型最新年份
  var fromPage = null;
  if (pageCtx && pageCtx.key) fromPage = byKey(pageCtx.key);
  else if (pageCtx && pageCtx.mh) {
    fromPage = (savedMatch && savedMatch.mh === pageCtx.mh ? savedMatch : null) ||
      list.filter(function (v) { return v.mh === pageCtx.mh; }).sort(function (a, b) { return b.year - a.year; })[0] || null;
  }
  var current = fromPage || fromUrl || savedMatch || fallback;
  var source = fromPage || fromUrl ? 'url' : (savedMatch ? 'saved' : 'default');

  var fields = {
    name: function (v) { return v.year + ' ' + v.make + ' ' + v.model; },
    year: function (v) { return v.year; },
    make: function (v) { return v.make; },
    model: function (v) { return v.model; },
    'make-model': function (v) { return v.make + ' ' + v.model; },
    'year-model': function (v) { return v.year + ' ' + v.model; }
  };

  function fitParam(v) {
    return 'veh_' + [v.year, v.make, v.lib_model].join(' ').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  }

  /* 09 LED Builder（2026-10-21 起全部上线车型）：Builder 数据由 06 同一份灯泡数据生成，所以「06 有这一年的数据（bsg 带 year）」= 有 Builder；
     每台车的 09 是它年份页的 Builder 视图 /pages/vehicle-year/<年份页>?view=builder */
  function builderOf(v) { return !!(v && v.yh && v.bsg && /[?&]year=/.test(v.bsg)); }
  function pageOnly(n, v) {
    /* 正式网址模式按年份页 Builder 判断；车型索引缺失（开发预览兜底清单，没有 yh）时照旧用 page_only['proto-shell-09'] 与预览网址（2.0.12 审查） */
    if (n === '09' && formal) return builderOf(v);
    var only = (data.page_only || {})['proto-shell-' + n];
    return !only || only.indexOf(v.key) >= 0;
  }
  // 预览网址（上线后仍可用：vehicles-bulb-size-guide-list 页 + 备用模板）：固定页面还没建好、或该车该灯位没有标准页时兜底
  function hostUrl(n, v, extra) {
    var u = new URL(HOST, window.location.origin);
    u.searchParams.set('view', 'proto-shell-' + n);
    u.searchParams.set('vehicle', v.key);
    Object.keys(extra || {}).forEach(function (k) { if (extra[k]) u.searchParams.set(k, extra[k]); });
    return u.pathname + u.search;
  }
  function bsgV2(url) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('view', 'bulb-size-guide-v2');
    // 带年份时加年份定位点（06 每个年份段都有 #year-<年份>[-<车型>]），浏览器直接落在表格上，不先闪 Banner（运营 2026-10-14）
    var y = u.searchParams.get('year');
    if (y && !u.hash) {
      var m = u.searchParams.get('model');
      u.hash = 'year-' + y + (m ? '-' + m.toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') : '');
    }
    return u.pathname + u.search + u.hash;
  }
  // 线上 search-result（任何车型、灯位都能打开）：该车该灯位没有灯位商品页时兜底
  function searchResultUrl(v, key) {
    var loc = locMap[key];
    if (!loc) return '';
    var u = new URL('/pages/search-result', window.location.origin);
    u.searchParams.set('q', ['LED Bulbs', v.make, v.lib_model, v.year, '/', '/', loc, '/'].join('_'));
    u.searchParams.set('year', v.year); u.searchParams.set('make', v.make); u.searchParams.set('model', v.lib_model);
    u.searchParams.set('focus_location', loc.replace(/ - Off-Road Use$/, ''));
    return u.pathname + u.search;
  }
  // 标准网址（运营 2026-09-28 标准 URL）；n = 页面编号 01–10
  function urlFor(n, v, opts) {
    opts = opts || {};
    var pos = opts.position || 'high-beam';
    switch (n) {
      case '01': return PAGES['01'] || hostUrl('01', v);
      case '02': return '/pages/vehicle/' + v.mh;
      case '03': return '/pages/vehicle-year/' + v.yh;
      case '04': return '/pages/vehicle-lighting/' + v.yh + (opts.state === 'bulbs' ? '?state=bulbs' : '');
      case '05': return v.fit.indexOf(pos) >= 0 ? '/pages/vehicle-fitment/' + v.key + '-' + pos : (searchResultUrl(v, pos) || '/pages/vehicle-lighting/' + v.yh);
      // 06：已上线的 Bulb Size Guide 页面。「品牌-车型」网址按运营 9-28 决定对外恢复旧版内容，从车型页进入时用新版视图
      // （view=bulb-size-guide-v2，canonical 仍是原网址，不产生重复收录）
      // 06 没有这一年的数据时（bsg 网址不带 year，如 1988–1998 Silverado），不进 06：新版 06 没指定年份会打开访客已保存的车，显示成别的年份
      /* 运营 2026-10-14：这一年没有灯泡数据的车（bsg 不带 year）也进这个车型的 06（新版，能看其他年份），不再退回 03 */
      case '06': return v.bsg ? bsgV2(v.bsg) : '/pages/vehicle-year/' + v.yh;
      // 车型库没有这台车的灯位（运营 2026-09-29 数据状态 none）：不进灯泡安装帮助，回这台车的 03
      /* 没有该灯位安装页的车（含车型库这一年完全没有灯位的车）进 07 通用安装帮助，不再退回 03（运营 2026-10-14） */
      case '07': return v.inst.indexOf(pos) >= 0 ? '/pages/install/' + v.key + '-' + pos : hostUrl('07', v, { position: pos });
      case '08': return pageOnly('08', v) ? hostUrl('08', v) : '/pages/vehicle-year/' + v.yh;
      case '09': return builderOf(v) ? '/pages/vehicle-year/' + v.yh + '?view=builder' : (PAGES['09'] ? PAGES['09'] + '?vehicle=' + encodeURIComponent(v.key) : '/pages/vehicle-year/' + v.yh);
      case '10': return PAGES['10'] ? PAGES['10'] + '?vehicle=' + encodeURIComponent(v.key) : hostUrl('10', v);
      default: return '';
    }
  }

  function withVehicle(url, v) {
    var u;
    // 以当前页地址解析：页面里的相对链接（如 ?view=proto-shell-03）要保留当前路径，按 origin 解析会丢路径、跳到首页
    try { u = new URL(url, window.location.href); } catch (e) { return url; }
    if (u.origin !== window.location.origin && !/(^|\.)auxito\.com$/.test(u.hostname)) return url;
    var view = u.searchParams.get('view') || '';
    var screen = /^proto-shell-(\d\d)$/.exec(view);
    if (formal && screen) {
      var next = urlFor(screen[1], v, { position: u.searchParams.get('position') || '', state: u.searchParams.get('state') || '' });
      if (next) return next + (u.hash && next.indexOf('#') < 0 ? u.hash : '');
    }
    if (view === 'proto-shell-06' && v.bsg) return v.bsg;
    // 05 灯位商品列表用 search-result 同一套参数（q 里带车型），按 search-result 的写法换车，不走 vehicle=
    var isPlp = u.pathname === '/pages/search-result' || view === 'proto-shell-05';
    if (/^proto-shell-/.test(view) && !(isPlp && u.searchParams.get('q'))) {
      // 这台车在目标页还没有内容（page_only）：改去它的 03 首页，不进显示别的车内容的页面
      var only = (data.page_only || {})[view];
      if (view === 'proto-shell-09' && formal ? !builderOf(v) : (only && only.indexOf(v.key) < 0)) { u.searchParams.set('view', 'proto-shell-03'); u.hash = ''; }
      // 预览模板只挂在预览页上：在标准网址页面（/pages/vehicle-year/… 等）里的相对链接 ?view=… 要回到预览页
      u.pathname = HOST;
      u.searchParams.delete('year'); u.searchParams.delete('make'); u.searchParams.delete('model');
      u.searchParams.set('vehicle', v.key);
      return u.pathname + u.search + u.hash;
    }
    if (isPlp && u.searchParams.get('q')) {
      var parts = u.searchParams.get('q').split('_');
      if (parts.length >= 4) { parts[1] = v.make; parts[2] = v.lib_model; parts[3] = v.year; }
      u.searchParams.set('q', parts.join('_'));
      if (u.searchParams.has('year')) u.searchParams.set('year', v.year);
      if (u.searchParams.has('make')) u.searchParams.set('make', v.make);
      if (u.searchParams.has('model')) u.searchParams.set('model', v.lib_model);
      u.searchParams.delete('qualifier');
      return u.pathname + u.search + u.hash;
    }
    if (u.pathname.indexOf('/products/') === 0) {
      u.searchParams.set('fit', fitParam(v));
      return u.pathname + u.search + u.hash;
    }
    return url;
  }

  // 当前页的页面编号与灯位（标准网址页面取 section 输出的 data-apsp-page，预览网址取 view / position 参数）
  var hereScreen = (pageCtx && pageCtx.screen) || ((/^proto-shell-(\d\d)$/.exec(params.get('view') || '') || [])[1]) || '';
  var herePosition = (pageCtx && pageCtx.position) || params.get('position') || '';
  /* 运营 2026-10-13：10 Off-Road Builder 对所有车型开放（01 选非上线车型点 Build an Off-Road Setup 也进 10）。
     网址带的 year / make / model 不在上线车型清单里时，本页只显示这台车：不套默认 / 已保存的上线车型，不给链接加车型参数
     （商品页 Fits On 不能显示别的车），面包屑车型链回旧版车型页 /pages/vehicle?year=&make=&model=。 */
  var outside = null;
  var page10Path = '';
  try { page10Path = PAGES['10'] ? new URL(PAGES['10'], window.location.origin).pathname : ''; } catch (e) { page10Path = ''; }
  var isScreen10 = hereScreen === '10' || (page10Path && window.location.pathname === page10Path); // 正式网址下 10 是固定页面，网址里没有 view
  var outsideSrc = null;
  if (isScreen10 && !fromPage && !fromUrl && !params.get('vehicle')) {
    if (params.get('year') && params.get('make') && params.get('model')) outsideSrc = { year: params.get('year'), make: params.get('make'), model: params.get('model'), fromUrl: true };
    else if (saved && !savedMatch) outsideSrc = { year: String(saved.year), make: saved.make, model: saved.model }; // 网址没带车：用访客保存的非上线车型
  }
  /* 09 LED Builder 固定页（/pages/lighting-builder，section 输出 data-apsp-page 的 home:true，页面内容是默认车 2003 Silverado 2500 HD）：
     2026-10-21 起全部车型可选。网址 vehicle= / year&make&model 或访客已保存的是有 Builder 的上线车型 → 换到它年份页的 Builder 视图；
     上线但没有 Builder 数据、或不在上线清单的车 → 本页按 outside 显示「这台车暂无 Builder」与去处，不显示默认车的商品。 */
  var builderHome = !!(formal && pageCtx && pageCtx.screen === '09' && pageCtx.home);
  var builderAway = '';
  if (builderHome) {
    var bt = fromUrl || (params.get('vehicle') || params.get('year') ? null : savedMatch);
    if (bt && bt.key !== pageCtx.key) {
      if (builderOf(bt)) builderAway = '/pages/vehicle-year/' + bt.yh + '?view=builder';
      else outsideSrc = { year: bt.year, make: bt.make, model: bt.model, launched: bt, supported: true, fromUrl: bt === fromUrl };
    } else if (!fromUrl && !params.get('vehicle')) {
      if (params.get('year') && params.get('make') && params.get('model')) outsideSrc = { year: params.get('year'), make: params.get('make'), model: params.get('model'), fromUrl: true };
      else if (saved && !savedMatch) outsideSrc = { year: String(saved.year), make: saved.make, model: saved.model };
    }
    if (builderAway && !(window.Shopify && window.Shopify.designMode)) window.location.replace(builderAway);
  }
  if (outsideSrc) {
    outside = outsideSrc;
    outside.name = outside.year + ' ' + outside.make + ' ' + outside.model;
    outside.legacyUrl = outside.launched ? '/pages/vehicle-year/' + outside.launched.yh
      : '/pages/vehicle?' + new URLSearchParams({ year: outside.year, make: outside.make, model: outside.model }).toString();
  }
  var outsideFromUrl = !!(outside && outside.fromUrl);
  var outsideLib = outsideSrc && outsideSrc.launched ? outsideSrc.launched.lib_model : '';
  if (outside) { delete outside.fromUrl; delete outside.launched; }

  /* 运营 2026-10-21：带明确车型的页面（03–05、07、08、09 年份页 Builder、10 网址带车）页头当前车型必须与页面主体一致——
     页面数据 / 网址给出的车优先，存为全站当前车型并刷新页头，不能还显示之前保存的另一台车。
     09 固定页的默认车（2003，home）和没带车的 10 不算明确车型，不改访客保存的车。 */
  function explicitVehicle() {
    if (builderAway) return null; // 马上换到那台车的 Builder 视图，由目标页保存
    if (outside) return outsideFromUrl ? { year: String(outside.year), make: outside.make, model: outsideLib || outside.model } : null;
    // 固定页（09 lighting-builder）只认网址给的车：网址正好是页面默认车时不跳转，也要保存（Astra 2.0.12 复审）；没给车不动访客保存的车
    var v = pageCtx && pageCtx.key ? (pageCtx.home ? fromUrl : fromPage) : fromUrl;
    return v ? { year: String(v.year), make: v.make, model: v.lib_model || v.model } : null;
  }
  function syncHeaderVehicle() {
    var v = explicitVehicle();
    var store = window.Auxito && window.Auxito.Vehicle && window.Auxito.Vehicle.Storage;
    if (!v || !store || typeof store.addVehicle !== 'function') return;
    var now = savedVehicle();
    if (now && String(now.year) === v.year && lc(now.make) === lc(v.make) && lc(now.model) === lc(v.model)) return;
    try {
      store.addVehicle(v);
      var utils = window.AuxitoVehicleUtils;
      if (utils && typeof utils.syncVehicleStorageUi === 'function') utils.syncVehicleStorageUi({ showSelectedState: true });
      window.dispatchEvent(new CustomEvent('auxito:vehicle-context-changed', { detail: { vehicle: store.load().current } }));
    } catch (e) { /* 存不了（隐私模式等）不影响页面 */ }
  }

  // 当前页换成另一台车的地址（选车卡确认后跳转用）
  function urlForHere(v, opts) {
    if (formal && hereScreen) {
      var next = urlFor(hereScreen, v, { position: (opts && opts.position) || herePosition, state: params.get('state') || '' });
      if (next) return next;
    }
    var u = new URL(window.location.href);
    u.searchParams.delete('year'); u.searchParams.delete('make'); u.searchParams.delete('model');
    u.searchParams.set('vehicle', v.key);
    return u.pathname + u.search + u.hash;
  }

  function saveVehicle(v) {
    var store = window.Auxito && window.Auxito.Vehicle && window.Auxito.Vehicle.Storage;
    if (!store || typeof store.addVehicle !== 'function') return;
    try {
      store.addVehicle({ year: String(v.year), make: v.make, model: v.lib_model });
      window.dispatchEvent(new CustomEvent('auxito:vehicle-context-changed', { detail: { vehicle: store.load().current } }));
    } catch (e) { /* 存不了（隐私模式等）不影响页面 */ }
  }

  // data-task-link（01 任务卡）/ data-guide-link（02 Guides 卡）不在这里改：它们由 interactions.js 按页面上选的 Year / Make / Model 拼地址，
  // 提前换成当前车型的正式网址会让之后选的车不生效（选 1998 却跳到 2015 / 2025）
  var LINK_ATTRS = ['href', 'data-target-url', 'data-href'];
  /* 09 暂无 Builder 时的「Check Bulb Sizes & Compatible LEDs」（运营 2026-10-22）：文案说查灯泡尺寸，就不能回 03。
     按 06 清单（data-directory，与 /pages/search、品牌页选车同一份）找这台车这一年的 06：有 → 进 06 并定位年份；没有 → /pages/search 继续查 */
  function bulbGuideLink(el, year, make, models) {
    var flat = function (x) { return String(x || '').toLowerCase().replace(/[^a-z0-9]/g, ''); };
    var src = el.getAttribute('data-directory');
    el.setAttribute('href', '/pages/search');
    if (!src || !year || !make) return;
    fetch(src, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (d) {
      var y = Number(year);
      var p = (d.pages || []).filter(function (e) {
        return flat(e[5]) === flat(make) && (e[6] || []).some(function (m) { return models.some(function (x) { return x && flat(m) === flat(x); }); }) && (e[3] || []).indexOf(y) >= 0;
      })[0];
      if (!p) return;
      var q = new URLSearchParams({ year: String(year), model: p[2] });
      el.setAttribute('href', /^\d/.test(p[0]) ? '/pages/' + p[0] + '?' + q.toString() : bsgV2('/pages/' + p[0] + '?' + q.toString()));
    }).catch(function () { /* 读不到清单就留在 /pages/search */ });
  }
  function applyOutside(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-apsp-only]'), function (el) { el.hidden = true; });
    Array.prototype.forEach.call(root.querySelectorAll('[data-apsp-v]'), function (el) {
      var f = fields[el.getAttribute('data-apsp-v')];
      if (f) el.textContent = f(outside);
    });
    Array.prototype.forEach.call(root.querySelectorAll('.apsp-crumb a[href*="view=proto-shell-03"], [data-apsp-outside-link]'), function (el) {
      el.setAttribute('href', outside.legacyUrl);
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-apsp-bulb-link]'), function (el) {
      bulbGuideLink(el, outside.year, outside.make, [outsideLib, outside.model]);
    });
    /* 只给非上线 / 没有内容的车看的说明（09 暂无 Builder） */
    Array.prototype.forEach.call(root.querySelectorAll('[data-apsp-outside]'), function (el) { el.hidden = false; });
    document.documentElement.setAttribute('data-apsp-vehicle', '');
  }
  function apply(root) {
    root = root || document;
    if (outside) { applyOutside(root); return; }
    // 车型专属素材（真实安装视频、车主评价等）：data-apsp-only="key key…" 只在这些车型上显示，其他车型先隐藏，不借用别的车的素材
    Array.prototype.forEach.call(root.querySelectorAll('[data-apsp-only]'), function (el) {
      var keys = el.getAttribute('data-apsp-only').split(/\s+/);
      el.hidden = keys.indexOf(current.key) < 0;
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-apsp-v]'), function (el) {
      var f = fields[el.getAttribute('data-apsp-v')];
      if (f) el.textContent = f(current);
    });
    Array.prototype.forEach.call(root.querySelectorAll('.apsp a[href], .apsp [data-target-url], .apsp [data-href]'), function (el) {
      // 指向 02 车型中心、文字是某个车型名的链接（01 Browse by Make 列表）：按文字找清单里的车型；当前车就是这个车型时保留当前年份；
      // 不在上线范围的车型去掉链接，只留名称
      var target = current;
      if (el.closest('[data-make-models]') && /view=proto-shell-02/.test(el.getAttribute('href') || '')) {
        var label = lc(el.textContent);
        var hits = list.filter(function (v) { return lc(v.model) === label || lc(v.make + ' ' + v.model) === label; });
        // 合写的车型名（如「A/B」）：按斜杠前的部分找，取最新年份（01 的 Silverado 2500/3500 已按运营 2026-09-29 拆成 2500 HD / 3500 HD 两项，按全名精确匹配）
        if (!hits.length && label.indexOf('/') > 0) {
          var head = label.split('/')[0].trim();
          hits = list.filter(function (v) { return lc(v.model).indexOf(head) === 0; });
        }
        // 不在上线车型清单里（运营 2026-09-29：非 Silverado）：不去 02，交给 01 选车卡按全站车型目录继承 Make + Model、选 Year 后进旧版车型首页
        if (!hits.length) {
          var makeCard = el.closest('[data-make-card]');
          el.removeAttribute('href');
          el.setAttribute('role', 'button');
          el.setAttribute('tabindex', '0');
          el.setAttribute('data-apsp-catalog', (makeCard ? makeCard.getAttribute('data-make-card') : '') + '|' + (el.textContent || '').trim());
          return;
        }
        target = hits.filter(function (v) { return v.key === current.key; })[0] || hits.sort(function (a, b) { return b.year - a.year; })[0];
      }
      LINK_ATTRS.forEach(function (attr) {
        var val = el.getAttribute(attr);
        if (!val || val.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(val)) return;
        var next = withVehicle(val, target);
        if (next !== val) el.setAttribute(attr, next);
      });
    });
    // 04 / 06 部分卡片点击时读这份 search-result 链接清单再跳转：清单里的链接也换成当前车型
    Array.prototype.forEach.call(root.querySelectorAll('script[data-apsp-plp-urls]'), function (s) {
      try {
        var urls = JSON.parse(s.textContent);
        Object.keys(urls).forEach(function (k) { if (typeof urls[k] === 'string') urls[k] = withVehicle(urls[k], current); });
        s.textContent = JSON.stringify(urls);
      } catch (e) { /* 清单格式不对就不改 */ }
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-apsp-bulb-link]'), function (el) {
      if (el.closest('[hidden]')) return; /* 有 Builder 的车不显示这张卡，不用读 06 清单 */
      bulbGuideLink(el, current.year, current.make, [current.lib_model, current.model]);
    });
    document.documentElement.setAttribute('data-apsp-vehicle', current.key);
  }

  /* 运营 2026-09-29：预览入口 ?view=proto-shell-02 / 03 / 04 没有固定车型，分类只按 Silverado 过滤、面包屑还能回到全站分类页，
     与上线的车型页不一致，按预览入口验收会误判。正式网址模式下直接换到当前车型的正式页面（与上线后一致）；
     01 / 09 / 10 固定页面未发布、05–08 另有用途，保持预览。主题编辑器里不跳，便于编辑模板。 */
  if (formal && !pageCtx && /^(02|03|04)$/.test(hereScreen) && !(window.Shopify && window.Shopify.designMode)) {
    var formalHere = urlFor(hereScreen, current, { state: params.get('state') || '' });
    if (formalHere && formalHere.indexOf('/pages/vehicle') === 0) window.location.replace(formalHere);
  }

  window.AuxitoProtoShellVehicle = {
    list: list,
    current: current,
    isDefault: current.key === (fallback && fallback.key),
    source: source, // url / saved / default：用户没选过车（default）时，Finder 等页面不预填
    saved: savedMatch, // 访客已保存、且在车型清单里的车（02 年份下拉只在存过这款车时预填）
    fields: fields,
    match: match,
    formal: formal,
    page: pageCtx,
    screen: hereScreen,
    position: herePosition,
    urlFor: urlFor,
    /* 这台车有没有 09 Builder（06 有这一年数据的上线车型都有，见 builderOf）：没有的车不出 09 入口，不把「Start builder」链到别的页面 */
    hasBuilder: function (v) { v = v || current; return !!(v && v.key) && pageOnly('09', v); },
    withVehicle: withVehicle,
    outside: outside, // 10 页网址带的非上线车型（{ year, make, model, name, legacyUrl }），其他情况为 null
    offroad: !!isScreen10, // 本页是 10 Off-Road Builder（对所有车型开放，选车卡按全站车型目录选车）
    builder: !!(formal && hereScreen === '09'), // 本页是 09 LED Builder（2026-10-21 起全部车型可选，选车卡同样按全站车型目录）
    builderHome: PAGES['09'] || '', // 09 固定页：选了非上线车型时去这里（带 year / make / model）显示暂无 Builder
    urlForHere: urlForHere,
    saveVehicle: saveVehicle,
    apply: apply
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { apply(); syncHeaderVehicle(); });
  else { apply(); syncHeaderVehicle(); }
})();
